"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridBlock = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var TextBlock_1 = require("../../atoms/TextBlock");
var Checkbox_1 = require("../../atoms/Checkbox");
var Text_1 = require("../../atoms/Text");
var styles_1 = __importDefault(require("./styles"));
var renderBlocks = function (blockData) {
    return blockData.map(function (block) {
        var component = block.component, _a = block.title, title = _a === void 0 ? '' : _a, _b = block.value, value = _b === void 0 ? false : _b, _c = block.columnSize, columnSize = _c === void 0 ? 3 : _c;
        if (component === 'checkbox') {
            return ((0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ item: true, xs: 12, "data-testid": "text-block" }, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: title, label: title, defaultChecked: Boolean(value), disabled: true }) }), "grid-block-".concat(title)));
        }
        return ((0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ item: true, md: columnSize, "data-testid": "text-block" }, { children: (0, jsx_runtime_1.jsx)(TextBlock_1.TextBlock, __assign({}, block)) }), "grid-item-".concat(title)));
    });
};
/**
 * @deprecated
 */
var GridBlock = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.divider, divider = _c === void 0 ? true : _c, blockData = _a.blockData, _d = _a.spacing, spacing = _d === void 0 ? 2 : _d, marginTop = _a.marginTop;
    var classes = (0, styles_1.default)({
        marginTop: marginTop,
    });
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ "data-testid": "grid-block", className: classes.root }, { children: [title ? ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ color: "primary", type: "text", weight: "bold", component: "legend", marginBottom: 1, className: classes.header }, { children: title }))) : undefined, (0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ container: true, spacing: spacing, component: "div" }, { children: renderBlocks(blockData) })), divider ? (0, jsx_runtime_1.jsx)(core_1.Divider, { className: classes.divider }) : undefined] })));
};
exports.GridBlock = GridBlock;
